"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useMultiStyleConfig, forwardRef } from "@chakra-ui/react";
import { SvgSpriteConsumer } from "../SvgSprite";
import { getSize, displayLabel } from "./helpers";
import { BadgeVariant } from "./Badge.types";
const Badge = forwardRef(({ label, iconId: svgId, iconColor: color, variant = BadgeVariant.MD, }, ref) => {
    const styles = useMultiStyleConfig("Badge", { variant, label });
    return (_jsxs(Box, Object.assign({ ref: ref, sx: styles.container }, { children: [label && Number.isInteger(label) && label > 0 ? (_jsx(Box, Object.assign({ sx: styles.badge }, { children: displayLabel({ variant, label }) }))) : null, _jsx(Box, Object.assign({ sx: styles.icon }, { children: _jsx(SvgSpriteConsumer, { svgId: svgId, color: color, size: getSize(variant) }) }))] })));
});
Badge.displayName = "Badge";
export default Badge;
//# sourceMappingURL=Badge.js.map